import NextivaAppBlock from './NextivaAppBlock';

export default NextivaAppBlock;
